<template>
  <div class="inner-box">
    <el-form size="mini" :model="form" ref="catInfoForm" class="components">

      <el-row>
        <el-col>
          <el-col :span="5">
            <el-form-item label="고객구분">
              <el-select v-model="form.siteType">
                <el-option value=''  label="전체">==전체==</el-option>
                <el-option
                    v-for="item in combos['siteType']"
                    :key="item.key"
                    :value="item.key"
                    :label="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="사이트ID" prop="catNm">
              <el-input v-model="form.siteId" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="지역구분">
              <el-select v-model="form.area">
                <el-option value=''  label="전체">전체</el-option>
                <el-option
                    v-for="item in combos['areaAgent']"
                    :key="item.key"
                    :value="item.key"
                    :label="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="센터명">
              <el-select v-model="form.asAgentId">
                <el-option value=''  label="전체">전체</el-option>
                <el-option
                    v-for="item in combos['areaAgentDetail']"
                    :key="item.key"
                    :value="parseInt(item.key)"
                    :label="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <el-col :span="8">
            <el-form-item label="사이트명">
              <el-input v-model="form.siteNm1"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item>
              <el-input v-model="form.siteNm2"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item>
              <el-input v-model="form.siteNm3"></el-input>
            </el-form-item>
          </el-col>
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <el-col :span="4">
            <el-form-item label="주소">
              <div style="display: flex; width: 100%">
                <el-input v-model="form.zipCd" style="width: 70%"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="addrOpenPopUp"></el-button>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item>
              <el-input v-model="form.addr1"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item>
              <el-input v-model="form.addr2"></el-input>
            </el-form-item>
          </el-col>
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <el-col :span="8">
            <el-form-item label="고객명">
              <el-input v-model="form.chargeNm"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="전화번호">
              <el-input v-model="form.telNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="핸드폰">
              <el-input v-model="form.hpNo"></el-input>
            </el-form-item>
          </el-col>
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <el-col :span="4">
            <el-form-item label="MA구분">
              <el-select v-model="form.maYn">
                <el-option value=''  label="전체">==전체==</el-option>
                <el-option
                    v-for="item in combos['maYn']"
                    :key="item.key"
                    :value="item.key"
                    :label="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="유/무상">
              <el-select v-model="form.payYn">
                <el-option value=''  label="전체">==전체==</el-option>
                <el-option
                    v-for="item in combos['payYn']"
                    :key="item.key"
                    :value="item.key"
                    :label="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="방번호">
              <el-input v-model="form.cyberRoomId" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-col>
      </el-row>

    </el-form>
  </div>

</template>

<script>
export default {
  name: "DefaultInfo",
  props: ['custParam' , 'parentNm'],
  data() {
    return {
      form: {
        addr1:"",
        addr2:"",
        area:"",
        areaId:"",
        areaKey:"",
        area_nm:"",
        asAgentId:"",
        asAgentNm:"",
        chargeNm:"",
        companyId:"",
        createDt:"",
        creatorId:"",
        creatorNm:"",
        cyberRoomId:"",
        deleteYn:"",
        hpNo:"",
        maYn:"",
        payYn:"",
        siteCd:"",
        siteId:"",
        siteNm1:"",
        siteNm2:"",
        siteNm3:"",
        siteType:"",
        telNo:"",
        updateDt:"",
        updatorId:"",
        updatorNm:"",
        zipCd:""
      },
      combos: {
        'siteType' : [],         //고객구분
        'areaAgent' : [],        //지역구분
        'areaAgentDetail':[],    //지역구분 상세
        'maYn' : [],             //M/A구분
        'payYn' : [],            //유/무상
      },
      tapName: "default",
    };
  },
  methods: {
    setSiteInfo() {
      Object.assign(this.form, this.custParam)
    },
    async init() {
      this.$store.commit('loading');
      await this.$http.post(`/api/siteMng/init`,{
        parentId: this.form.areaId
      })
      .then(response => {
        this.combos['siteType'] = response.data.siteType;        //고객구분
        this.combos['areaAgent'] = response.data.areaAgent;      //지역구분
        this.combos['areaAgentDetail'] = response.data.areaAgentDetail;      //지역구분 상세
        this.combos['maYn'] = response.data.maYn;                //M/A구분
        this.combos['payYn'] = response.data.payYn;              //유/무상
      }).finally(() => {
        //this.goOpen();
        this.$store.commit('finish');
      });
    },
    addrOpenPopUp() {
      const vm = this;
      // eslint-disable-next-line no-undef
      new daum.Postcode({
        oncomplete: (data) => {
          var fullAddr = data.address; //최종 주소 변수
          var extraAddr = ''; // 조합형 주소 변수

          if(data.userSelectedType === 'R') {
            if(data.bname) {
              extraAddr += data.bname;
            }
            if(data.buildingName) {
              extraAddr += (extraAddr ? ', '+ data.buildingName : data.buildingName);
            }
            fullAddr += (extraAddr ? ' ('+ extraAddr + ')' : '');
          } else {
              fullAddr = data.jibunAddress;
          }

          vm.form.zipCd = data.zonecode;
          vm.form.addr1 = fullAddr;
          vm.form.addr2 = ''; // 초기화

          vm.reloadAsAgent(data.zonecode);

        }
      }).open();
    },
    async reloadAsAgent(vZipCd){
      await this.$http.post(`/api/asMng/call/selectServiceEngineerFind`, {zipCd: vZipCd})
          .then(response => {
            const data = response.data[0];
            this.form.area =  data.area2;
            this.form.asAgentId = parseInt(data.asAgentId);
          });
    },
  },
  beforeMount() {
    this.init();
  },
  afterMount(){

  },
  watch: {
    custParam() {
      this.setSiteInfo();
    },
    'form.area'(val) {
      if(val) {
        this.combos['areaAgent'].forEach(x=>{
          if(x.key == val) {
            this.form.areaId = x.id;
            this.form.areaKey = x.key;
          }
        })
      }
      this.init();
    },
  }
}

</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 0;
  // &:last-child {
  //   margin-bottom: 0;
  // }
}
.el-form {
  border: 1px solid #c7c7c7;
  padding: 10px 0 0 10px;
  border-radius: 5px;
}
.el-form-item {
  margin-right: 10px;
  // &:last-child {
  //   margin-right: 0;
  // }
}
.large-textarea{
  padding: 0 24px !important
}
.el-select {
  width: 100%;
}
</style>